<template>
  <div class="empty-box">
    <div class="empty">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-box {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  .empty {
    width: 224px;
    height: 147px;
    background: url(https://cdn-hz.renrenjiang.cn/teacher_center/website/icon_table_empty.png)
      center top / 224px 147px no-repeat;
    color: #acacac;
    text-align: center;
    padding-top: 177px;
  }
}
</style>
